import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "@/lib/api";
import { PostCard } from "@/components/PostCard";
import { PostComposer } from "@/components/PostComposer";
import { useAuth } from "@/context/AuthContext";
import { timeAgo } from "@/lib/format";

export default function Announcements() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/announcements");
      setItems(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const upsert = (updated) =>
    setItems((prev) => prev.map((p) => (p.id === updated.id ? updated : p)));

  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Announcements</h1>
          <p className="text-sm text-muted-foreground mt-1">Official CCNEO updates & events.</p>
        </div>
        <div className="w-12 h-12 rounded-2xl bg-[#B31B1B]/10 text-[#B31B1B] grid place-items-center shrink-0">
          <Megaphone className="w-6 h-6" />
        </div>
      </div>

      {user?.role === "admin" && (
        <div>
          <div className="text-xs uppercase tracking-wider text-[#B31B1B] font-semibold mb-2" data-testid="admin-composer-label">Admin — Create announcement</div>
          <PostComposer
            defaultCategory="announcements"
            onPosted={(p) => setItems((prev) => [p, ...prev])}
          />
        </div>
      )}

      {loading ? (
        <div className="text-center py-12 text-muted-foreground" data-testid="announcements-loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground bg-white rounded-2xl border border-border" data-testid="announcements-empty">
          No announcements yet.
        </div>
      ) : (
        <div className="space-y-4" data-testid="announcements-list">
          {items.map((p) => (
            <PostCard key={p.id} post={p} onChange={upsert} onDelete={remove} />
          ))}
        </div>
      )}
    </div>
  );
}
